import { createContext, useContext } from 'react';
import type { RefObject } from 'react';
import type { ActivityFocus } from './queries';

export interface ShellUi {
  /** Opens the ⌘K palette. */
  readonly openPalette: () => void;
  /** Opens the Activity panel, optionally highlighting one record's history (design `openActivity`). */
  readonly openActivity: (focus?: ActivityFocus) => void;
  /** The scrolling `<main>`. */
  readonly mainRef: RefObject<HTMLElement | null>;
}

export const ShellContext = createContext<ShellUi | null>(null);

const NOOP_SHELL: ShellUi = {
  openPalette: () => undefined,
  openActivity: () => undefined,
  mainRef: { current: null },
};

/** Shell actions for screens; a no-op outside the shell (isolated component tests). */
export function useShellUi(): ShellUi {
  return useContext(ShellContext) ?? NOOP_SHELL;
}
